import { render, staticRenderFns } from "./ComplaintAcceptView.vue?vue&type=template&id=3add059a"
import script from "./ComplaintAcceptView.vue?vue&type=script&lang=js"
export * from "./ComplaintAcceptView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports